import React from 'react';
import ProductCard from '../ProductCard';

const StyleSelectionStep = ({ onSelect, onNotSure, selectedStyle, options, title = 'Select Your Style' }) => {
  return (
    <div className="w-full">
      {/* Title */}
      <h2 className="mb-12 text-center text-[24px] font-bold text-black">
        {title}
      </h2>

      {/* Style Grid */}
        <div className={`mx-auto grid max-w-[1240px] grid-cols-1 gap-6 px-4 sm:grid-cols-2 ${options.length === 4 ? 'md:grid-cols-2' : 'md:grid-cols-3'}`}>
        {options.map((option) => (
          <ProductCard
            key={option.id}
            image={option.image}
            title={option.title}
            isSelected={selectedStyle === option.id}
            onClick={() => onSelect(option.id)}
          />
        ))}
      </div>

      {/* Not sure — skips the remaining specification steps and goes straight to the contact form */}
      {onNotSure && (
        <div className="mx-auto mt-10 max-w-[700px] px-4">
          <button
            type="button"
            onClick={onNotSure}
            className="flex min-h-[80px] w-full items-center justify-center rounded-lg border-2 border-gray-200 p-4 text-center text-base font-bold text-black transition-all hover:border-gray-300"
          >
            I'm not sure
          </button>

          <p className="mx-auto mt-4 text-center text-base text-gray-600">
            Don't worry if you're not sure - we can help you determine the exact requirements during your consultation.
          </p>
        </div>
      )}
    </div>
  );
};

export default StyleSelectionStep;
